module.exports = __webpack_public_path__ + "img/corner-down-left.7c9546e3.svg";